import type { EntityStatus } from '@ms/yammer-data-support';

import type { Group } from '../types';

export enum MyGroupsFilter {
  All,
  AdminOnly,
}

export interface FilteredMyGroups {
  readonly cursor: string | null;
  readonly hasNextPage: boolean;
  readonly groupIds: Group['id'][];
  readonly favoriteGroupIds: Group['id'][];
  readonly status: EntityStatus;
  readonly requestGeneration?: number;
}

/**
 * The Redux bucket key for a MyGroups collection. It is derived from both the filter and the
 * `bridgeToViewerCommunityIdSets` flag so the left-nav collection (which bridges into
 * `viewerCommunityIdSets`) is stored separately from the /discover-groups/my-groups page collection.
 * Mixing them would let the nav's 15-item paginated window and the page's larger window clobber each other.
 */
export type MyGroupsStateKey = string;

export const getMyGroupsStateKey = (
  filteredBy: MyGroupsFilter,
  bridgeToViewerCommunityIdSets: boolean
): MyGroupsStateKey => `filter:${filteredBy}-bridgeNav:${bridgeToViewerCommunityIdSets}`;

export type MyGroups = Partial<Record<MyGroupsStateKey, FilteredMyGroups>>;
